const colors = {
  transparent: 'transparent',
  current: 'currentColor',
  link: {
    DEFAULT: '#179EEE',
  },
  white: {
    DEFAULT: '#FFFFFF',
  },
  black: {
    DEFAULT: '#000000',
  },
  primary: {
    dark: '#0234E1',
    DEFAULT: '#1774F0',
    light: '#8AB9F7',
    lightness: '#eaf1fe', // DEFAULT/0.1
  },
  secondary: {
    dark: '#5D7186',
    DEFAULT: '#9DA9B6',
    light: '#DDE5ED',
    lightness: '#F4F7F9', // DEFAULT/0.1
  },
  success: {
    dark: '#00B670',
    DEFAULT: '#03D8A9',
    light: '#9AEFDC',
    lightness: '#ecfcf7', // DEFAULT/0.1
  },
  danger: {
    dark: '#D1160E',
    DEFAULT: '#E74C3C',
    light: '#F5B7B1',
    lightness: '#feedec', // DEFAULT/0.1
  },
  warning: {
    dark: '#E14C00',
    DEFAULT: '#F08C00',
    light: '#F9D199',
    lightness: '#fef4e9', // DEFAULT/0.1
  },
  gray: {
    black: '#1E2535',
    dark: '#5D7186',
    DEFAULT: '#9DA9B6',
    light: '#DDE5ED',
    lightest: '#F4F7F9',
    lightness: '#fafbfc', // DEFAULT/0.5
  },
  accessory: {
    '1': '#E25D6D',
    '2': '#9775FA',
    '3': '#F06595',
    '4': '#C0EB75',
    '5': '#179EEE',
  },
};

export default colors;
